export enum SpinnerSizes {
    Default = 'default',
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}